import React from 'react'
import NavBarEmployer from '../components/NavBarEmployer'
import Hero from '../components/EmployerHome/Hero'
import Footer from '../components/Footer'

function EmployerHome() {
  return (
    <div>
        <NavBarEmployer />
        <Hero />
        <Footer />
    </div>
  )
}

export default EmployerHome